module.exports = __webpack_public_path__ + "4b9b2709223e4b69355b234adbb783cc.svg";